import Layout from '@/views/layout/Layout'
import SimpleRouterView from '@/views/layout/SimpleRouterView'
import httpVueLoader from 'http-vue-loader'
import loginRest from '@/rest/login'
import VueCookies from 'vue-cookies'
import genericPages from '@/router/genericPages'

import intersection from 'lodash/intersection'
import cloneDeep from 'lodash/cloneDeep'
import userStorage from "@/utils/userStorage";

/**
 * Use page.role to determine if the current user has permission
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {
  if (route.roles) {
    return roles.some(role => route.roles.includes(role))
  } else {
    return true
  }
}

/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param roles
 */
export function filterPagesByRoles (routes, roles) {
  const res = []

  routes.forEach(route => {
    const tmp = { ...route }
    if (hasPermission(roles, tmp)) {
      if (tmp.children) {
        tmp.children = filterPagesByRoles(tmp.children, roles)
      }
      res.push(tmp)
    }
  })

  return res
}

export function filterPagesByPermissions(userPermissions, pages) {
  let permittedPages = pages.filter(page => {
    let isPagePermitted = false;
    if (page.permissions == null) {
      isPagePermitted = true;
    } else {
      isPagePermitted = intersection(userPermissions, page.permissions).length > 0;
    }

    // recursion to check children
    if (page.children != null) {
      page.children = filterPagesByPermissions(userPermissions, page.children);
      // Parent page is just menu, then disable it when no children exist
      isPagePermitted = (page.children.length > 0);
    }
    return isPagePermitted;
  })
  return permittedPages;
}


const app = {
  state: {
    packageVersion: process.env.PACKAGE_VERSION || '0',
    buildDate: process.env.BUILD_DATE || 'unknown',
    // availableLanguages: ['en', 'ru', 'ua', 'az', 'by', 'cn', 'es', 'kz', 'ro'],
    availableLanguages: ['ru'],
    language: VueCookies.get('language'),
    languages: VueCookies.get('languages'),
    sidebar: {
      opened: (() => {
        let sidebarStatus = VueCookies.get('sidebarStatus')
        return VueCookies.get('sidebarStatus') === '1'
      })(),
      withoutAnimation: false
    },
    genericPages,
    pages: [],
    routes: [],
    initialized: false,
    devMode: false
  },
  mutations: {
    SET_INITIALIZED (state, initialized) {
      state.initialized = (initialized === undefined) ? true : initialized
    },
    SET_LANGUAGE (state, lang) {
      console.log('mutations setLanguage: ', lang)

      let languages = (state.languages != null) ? ((typeof state.languages === 'object') ? state.languages : JSON.parse(state.languages)) : []
      if (languages && languages.available) {
        if (!lang || languages.available.indexOf(lang) < 0) {
          state.language = languages.national
        } else {
          state.language = lang
        }
      } else {
        state.language = 'ru'
      }

      VueCookies.set('language', state.language, -1, '/')
    },
    setLanguages (state, languages) {
      console.log('mutations setLanguages: ', languages)
      languages.available = languages.available.filter(l => state.availableLanguages.indexOf(l) >= 0)
      state.languages = JSON.stringify(languages)
      VueCookies.set('languages', state.languages, -1, '/')
    },
    SET_TRANSLATES (state, translates) {
      console.log('mutations SET_TRANSLATES: ', translates)
      state.translates = JSON.stringify(translates)
      window.localStorage.setItem('translates', state.translates)
    },
    setPages (state, loadedPages) {
      loadedPages.forEach(function (page) {
        app.setDefaults(page)
      })
      state.pages = []
      state.pages.push(...loadedPages)
    },
    addPages (state, loadedPages) {
      loadedPages.forEach(function (page) {
        app.setDefaults(page)
      })
      state.pages.push(...loadedPages)
    },
    addRoutes (state, routes) {
      state.routes.push(...routes)
    },
    TOGGLE_SIDEBAR: state => {
      if (!state.sidebar.opened) {
        VueCookies.set('sidebarStatus', 1, -1, '/')
      } else {
        VueCookies.set('sidebarStatus', 0, -1, '/')
      }
      state.sidebar.opened = !state.sidebar.opened
      document.MeridianVue.debug && console.log('sidebar.opened = %o', state.sidebar.opened)
      state.sidebar.withoutAnimation = false
    },
    CLOSE_SIDEBAR: (state, withoutAnimation) => {
      VueCookies.set('sidebarStatus', 1, -1, '/')
      state.sidebar.opened = false
      state.sidebar.withoutAnimation = withoutAnimation
    },
    SET_DEV_MODE: (state, devMode) => {
      userStorage.setUserData({devMode})
      state.devMode = !!devMode
    }
  },
  actions: {
    initialization (context, initialized) {
      context.commit('SET_INITIALIZED', initialized)
      context.commit('SET_DEV_MODE', userStorage.getUserData().devMode)
    },
    setLanguage (context, payload) {
      console.log('action setLanguage: %o, %o', payload.lang)
      context.commit('SET_LANGUAGE', payload.lang)
    },
    setLanguages (context, payload) {
      context.commit('setLanguages', payload.langs)
    },
    setTranslates (context, payload) {
      context.commit('SET_TRANSLATES', payload.translates)
    },

    buildPages (context, {roles, permissions}) {
      return new Promise(function (success, fail) {
        // TODO: request pages from server
        document.MeridianVue.debug && console.log('TODO: request pages from server')
        window.setTimeout(function () {
          success([{
            name: 'Flight list',
            path: '/flight-list',
            // layout: `<template><div>##layout##</div></template> <script type="module"> module.exports = { computed: { message() { return "Flight list page"; }, pages() { return JSON.stringify(this.$store.getters.getPages); } } }; </script> <style scoped> h2 { background-color: salmon; } </style>`,
            template: `<template> <div> <h2>{{message}}</h2> <router-link to="ajshdkajsh">wrong route</router-link> <hello-world ></hello-world> <label>{{pages}}</label> </div> </template> <script type="module"> module.exports = { computed: { message() { return "Flight list page"; }, pages() { return JSON.stringify(this.$store.getters.getPages); } } }; </script> <style scoped> h2 { background-color: salmon; } </style>`,
            // template: `http://192.168.200.110:8080/test/flight-list.vue`,
            // permissions: ['FLIGHT_LIST_VIEW'],
            // roles: [],
            portlets: {
              place1: ['<hello-world :columns="ETD,ETA"></hello-world> <label>{{pages}}</label>'],
              place2: [
                '<h2>{{message}}</h2>',
                '<div>{{description}}</div>'
              ]
            },
            settings: {
              title: 'main.FlightList.title',
              useLayout: true,
              style: 'table',
              hidden: true
            }
          }])
        }, 100)
      }).then((loadedPages) => {
        loadedPages.forEach(function (page) {
          page.component = httpVueLoader(JSON.stringify(page))
        })
        return loadedPages
      }).then((loadedPages) => {
        // merge loaded pages with generic

        // check permission page/user
        let permittedGenericPages = []
        let permittedLoadedPages = []
        let userPermissions = permissions != null ? permissions : [];
        if (permissions != null) {
          permittedGenericPages = filterPagesByPermissions(userPermissions, cloneDeep(context.getters.getGenericPages));
          permittedGenericPages = filterPagesByRoles(permittedGenericPages, roles)

          permittedLoadedPages = filterPagesByPermissions(userPermissions, cloneDeep(loadedPages));
          permittedLoadedPages = filterPagesByRoles(permittedLoadedPages, roles)
        }
        console.warn('[buildPages] initial: %o, permitted %o',
          {generic: context.getters.getGenericPages, loaded: loadedPages},
          {generic: permittedGenericPages, loaded: permittedLoadedPages})

        // context.commit('setPages', permittedGenericPages)
        context.commit('setPages', permittedGenericPages)
        context.commit('addPages', permittedLoadedPages)
      }).then(() => {
        // generate routes
        let routes = context.getters.getPages.map(p => app.createRoute(p))

        // add default route
        routes.push({
          path: '/*',
          component: () => import('@/views/404')
        })

        return routes
      })
    },
    toggleSideBar (context) {
      document.MeridianVue.debug && console.log('action toggleSideBar')
      context.commit('TOGGLE_SIDEBAR')
    },
    closeSideBar (context, { withoutAnimation }) {
      document.MeridianVue.debug && console.log('action closeSideBar')
      context.commit('CLOSE_SIDEBAR', withoutAnimation)
    },
    setDevMode (context, devMode) {
      context.commit('SET_DEV_MODE', devMode)
    }
  },

  getters: {
    appVersion: (state) => {
      return state.packageVersion
    },
    appBuildDate: (state) => {
      return state.buildDate
    },
    getLanguage: (state) => {
      return state.language
    },
    isLanguageEn: (state) => {
      return state.language == null || state.language.toLowerCase() === 'en'
    },
    isLanguageRu: (state) => {
      return state.language == null || state.language.toLowerCase() === 'ru'
    },
    getLanguages: (state) => {
      return (state.languages != null) ? ((typeof state.languages === 'object') ? state.languages : JSON.parse(state.languages)) : []
    },
    getAvailableLanguages: (state) => {
      return state.availableLanguages
    },
    getTranslates: (state) => {
      // window.localStorage.setItem('translates', JSON.stringify(state.translates))
      return state.translates != null ? JSON.parse(state.translates) : {}
    },
    getSidebar: (state) => {
      return state.sidebar
    },
    getPages: (state) => {
      return state.pages
    },
    getGenericPages: (state) => {
      return state.genericPages
    },
    getPageRoutes: (state) => {
      return state.routes
    },
    devMode: (state) => {
      return state.devMode
    }
  },
  setDefaults: (page) => {
    page.settings = page.settings || {}
    page.settings.hidden = page.settings.hidden || false
  },
  createRoute: (page) => {
    let route = {
      path: page.path,
      alias: page.alias
    }

    // create route for current page
    if (typeof page.redirect !== 'undefined') {
      route.redirect = page.redirect
    }
    if (page.settings && page.settings.useLayout) {
      route.component = Layout
      if (typeof page.component !== 'undefined') {
        let childrenRoute = {
          path: '',
          component: page.component
        }
        if (typeof page.props !== 'undefined') {
          childrenRoute.props = page.props
        }
        route.children = [ childrenRoute ]
      }
    } else {
      if (typeof page.component !== 'undefined') {
        route.component = page.component
        if (typeof page.props !== 'undefined') {
          route.props = page.props
        }
      }
    }

    // create routes for children
    if (typeof page.children !== 'undefined') {
      route.children = route.children || []
      page.children.forEach(function (child) {
        route.children.push(app.createRoute(child))
      })
      if (typeof route.component === 'undefined') {
        route.component = SimpleRouterView
      }
    }
    return route
  }
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js